import { MetaInfoState } from '@sravni/react-silent-authentication-form/dist/types/components/ContextProvider/components/MetainfoProvider';

const MetaInfoStateConfig: MetaInfoState = {
    authCodeChannel: 'Sms',
    source: 'Анкета подбора кредита',
    customer: 'creditselection-frontend',
    productName: 'Старый Подбор кредита',
};

export const AuthInlineFormConfig = {
    texts: {
        consentsScreenTitle: 'Нужно ваше согласие, чтобы прислать вам данные об одобрении',
        bannerTitle: 'Кредиты на Сравни',
        bannerAdsTextsList: [
            'Проверка доступной суммы кредита',
            'Получите решение онлайн',
            'Предложения от топовых банков',
        ],
        advertisingCheckboxLabel: 'Согласен на получение данных об одобрении и {link|рекламных сообщений}',
    },
    metaInfo: MetaInfoStateConfig,
};
